








































import { Vue, Component } from "vue-property-decorator";
import { Field, Cell, CellGroup, Popup, Picker, DatetimePicker } from "vant";

@Component({
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker,
  },
})
export default class extends Vue {
  //data
  value = "";
  columns = [this.$root.$t('mall_modules_frequentercardfill_dongfanghangkong') as string, this.$root.$t('mall_modules_frequentercardfill_zhongguohangkong') as string, this.$root.$t('mall_modules_frequentercardfill_nanfanghangkong') as string];
  isAirline = false;

  onConfirm(value: string) {
    this.value = value;
    this.isAirline = false;
  }
  back() {
    history.back();
  }
}
